<template>
  <span v-if="thanksToPresent">
    thanks to <span v-for="(lifeArea, index) in thanksTo">
      <LifeArea :lifeArea="lifeArea" class=""/>{{delimiter(index)}}
    </span>
  </span>
  <span v-else></span>
</template>

<script>
import LifeArea from './LifeArea'

export default {
  components: {
    LifeArea
  },
  props: ['thanksTo'],
  data () {
    return {
    }
  },
  computed: {
    thanksToPresent () {
      return this.thanksTo && this.thanksTo.length > 0
    }
  },
  methods: {
    delimiter (index) {
      if (index === this.thanksTo.length - 1) {
        return null
      } else if (index === this.thanksTo.length - 2) {
        return ' and'
      } else {
        return ', '
      }
    }
  },
  created () {
  },
}
</script>

<style lang="scss">

.saved_review {
  .vx-card__header {
    padding: 0.6rem
  }
}

</style>
